import { LocalesEnum } from 'shared/enums/LocalesEnum';
import { RegionsEnum } from 'shared/enums/RegionsEnum.ts';
import { RankedProductInterface } from 'shared/interfaces/RankedProductInterface.ts';
import { AttributesClassComboInterface } from 'shared/interfaces/AttributesClassComboInterface.ts';
import { getDefaultLocale } from 'shared/mappers/getDefaultLocale.ts';
import { Product } from './Product';

export const createMapToProduct = (rawName: LocalesEnum) => (
    { id, label, attributes }: { id: string; label: string; attributes: string },
) => new Product(id, label, attributes, rawName);

export const createMapToRankedProduct = (region: RegionsEnum) => (
    { id, label, attributes, rank }: { id: string; label: string; attributes: string; rank: number },
): RankedProductInterface => ({
    product: new Product(id, label, attributes, getDefaultLocale(region)),
    rank,
});

export const createMapToCombo = (region: RegionsEnum) => (
    { id, label, attributes, type }: { id: string; label: string; attributes: string; type: number },
): AttributesClassComboInterface => ({
    product: (new Product(id, label, attributes, getDefaultLocale(region))).getAttributes(),
    type,
});
